import { Plugins } from '@leverege/plugin';
import CustomTextDetail from "./CustomTextDetail.js";
import CustomTextDetailModel from "./CustomTextDetailModel.js";
import CustomTextDetailRenderer from "./CustomTextDetailRenderer.js";
import CustomTextEditor from "./textEditor/CustomTextEditor.js";
import Editor from "./textEditor/PluginSetup.js";
function install(opts = Plugins) {
  opts.addPlugin('Detail', CustomTextDetail);
  opts.addPlugin('Model', {
    type: CustomTextDetailModel.TYPE,
    model: CustomTextDetailModel
  });
  opts.addPlugin('ModelEditor', {
    type: CustomTextDetailModel.TYPE,
    editor: CustomTextEditor
  });
  opts.addPlugin('DetailRenderer', {
    type: CustomTextDetailModel.TYPE,
    renderer: CustomTextDetailRenderer
  });
  Editor.install(opts);
}
export default {
  install
};